import { MdoBasketUploadCheckResponse } from '@epicuro-next/data/baskets';
import { createReducer, on } from '@ngrx/store';
import { ValidationResult } from 'graphql-api/baskets-api-interfaces';

import {
  checkMDOBasket,
  checkMDOBasketFailure,
  checkMDOBasketSuccess,
  importMDOBasket,
  importMDOBasketFailure,
  importMDOBasketSuccess,
  resetUploadBasketState,
  uploadSDOBasket,
  uploadSDOBasketFailure,
  uploadSDOBasketSuccess,
} from '../actions/upload-basket-actions';

export const uploadBasketFeatureKey = 'basket-upload';

export interface State {
  isSDOUploading: boolean;
  sdoValidationResults: ValidationResult[] | null;
  isMDOChecking: boolean;
  isMDOImporting: boolean;
  mdoUploadCheckResult: MdoBasketUploadCheckResponse | null;
  error: string | null;
}

export const initialState: State = {
  isSDOUploading: false,
  sdoValidationResults: null,
  isMDOChecking: false,
  isMDOImporting: false,
  mdoUploadCheckResult: null,
  error: null,
};

export const reducer = createReducer(
  initialState,
  on(
    uploadSDOBasket,
    (state): State => ({
      ...state,
      isSDOUploading: true,
    }),
  ),

  on(
    uploadSDOBasketSuccess,
    (state, { validationResults }): State => ({
      ...state,
      isSDOUploading: false,
      sdoValidationResults: validationResults,
    }),
  ),

  on(
    uploadSDOBasketFailure,
    (state, { error }): State => ({
      ...state,
      isSDOUploading: false,
      error,
    }),
  ),

  on(
    checkMDOBasket,
    (state): State => ({
      ...state,
      isMDOChecking: true,
    }),
  ),

  on(
    checkMDOBasketSuccess,
    (state, { mdoUploadCheckResult }): State => ({
      ...state,
      mdoUploadCheckResult,
      isMDOChecking: false,
    }),
  ),

  on(
    checkMDOBasketFailure,
    (state, { error }): State => ({
      ...state,
      error,
      isMDOChecking: false,
    }),
  ),

  on(
    importMDOBasket,
    (state): State => ({
      ...state,
      isMDOImporting: true,
    }),
  ),

  on(
    importMDOBasketSuccess,
    (state): State => ({
      ...state,
      isMDOImporting: false,
    }),
  ),

  on(
    importMDOBasketFailure,
    (state, { error }): State => ({
      ...state,
      isMDOImporting: false,
      error,
    }),
  ),

  on(
    resetUploadBasketState,
    (): State => ({
      ...initialState,
    }),
  ),
);
